import React, { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: 'About',    href: '#about'    },
  { label: 'Services', href: '#services' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact',  href: '#contact'  },
];

const Nav = () => {
  const [active, setActive]   = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const sections = NAV_ITEMS.map(({ href }) =>
      document.querySelector(href)
    ).filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive('#' + entry.target.id);
        });
      },
      { threshold: 0.4 }
    );

    sections.forEach((s) => observer.observe(s));
    return () => sections.forEach((s) => observer.unobserve(s));
  }, []);

  // close menu on scroll
  useEffect(() => {
    const close = () => setMenuOpen(false);
    window.addEventListener('scroll', close, { passive: true });
    return () => window.removeEventListener('scroll', close);
  }, []);

  const scrollTo = (href) => {
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="navbar">
      <a
        href="#hero"
        className="navbar-logo"
        onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
      >
        tg<span>.</span>dev
      </a>

      {/* Desktop links */}
      <ul className="navbar-links">
        {NAV_ITEMS.map(({ label, href }) => (
          <li key={href}>
            <button
              className={active === href ? 'nav-active' : ''}
              onClick={() => scrollTo(href)}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>

      {/* Hamburger button — mobile only */}
      <button
        className={`hamburger${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      {/* Mobile dropdown */}
      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        {NAV_ITEMS.map(({ label, href }) => (
          <button
            key={href}
            className={active === href ? 'nav-active' : ''}
            onClick={() => scrollTo(href)}
          >
            {label}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Nav;
